// extracted by mini-css-extract-plugin
module.exports = {"item":"SidebarOption_item__2fE87","active":"SidebarOption_active__1L4es"};